import { render, staticRenderFns } from "./main-contents.vue?vue&type=template&id=a1356850&scoped=true&lang=pug&"
import script from "./main-contents.vue?vue&type=script&lang=js&"
export * from "./main-contents.vue?vue&type=script&lang=js&"
import style0 from "./main-contents.vue?vue&type=style&index=0&id=a1356850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1356850",
  null
  
)

export default component.exports